import React, { Component } from "react";
import Cut from "./Cut";

class Cutlist extends Component {
  state = {
    cutlist: [""]
  };

  onRemove = index => {
    this.setState({
      cutlist: this.state.cutlist.filter((x, i) => i !== index)
    });
  };
  render() {
    return (
      <React.Fragment>
        <nav className="navbar is-light">
          <div className="navbar-brand">
            <a className="navbar-item" href="/">
              Miter Cut List
            </a>
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <div className="field is-grouped">
                <p className="control">
                  <a
                    className="button is-primary"
                    onClick={() => {
                      this.setState({
                        cutlist: [...this.state.cutlist, ""]
                      });
                    }}
                  >
                    <span className="icon">
                      <i className="fas fa-plus-square" />
                    </span>
                    <span>Add New Cut</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </nav>

        <div className="section">
          <div className="container-fluid">
            <h1 className="title">Your Cut List</h1>
            <h2 className="subtitle">
              A simple way to visualize your miter cuts and create a cut list.
            </h2>

            <p>
              Remember to place the molding <strong>bottom side up.</strong>
            </p>
            <p>The bottom is usually the most decorative edge.</p>
          </div>
        </div>
        <div className="section">
          <div className="container-fluid">
            {this.state.cutlist.map((x, i) => (
              <Cut
                onRemove={() => {
                  this.onRemove(i);
                }}
                key={i}
                index={i}
                {...x}
              />
            ))}
          </div>
        </div>

        <div className="section">
          <div className="container-fluid">
            <a
              className="button is-primary is-large"
              onClick={() => {
                this.setState({
                  cutlist: [...this.state.cutlist, ""]
                });
              }}
            >
              <span className="icon">
                <i className="fas fa-plus-square" />
              </span>
              <span>Add New Cut</span>
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Cutlist;



// WEBPACK FOOTER //
// ./src/Cutlist.js